import { FC, ReactElement, ReactNode } from "react";
import {
    useTheme,
    useMediaQuery,
    Grid2 as Grid,
    Typography,
    Stack,
} from "@mui/material";

import ResponsiveIcon from "./ResponsiveIcon";

interface PageHeaderProps {
    /**
     * Title of the page
     */
    title: string | ReactNode;
    /**
     * Display this element if it is defined, right side of the title line
     */
    toolbar?: ReactNode;
    /**
     * If it is true, mobile icon will be placed in title for marking the page is optimized for mobile too
     */
    responsive?: boolean;
}

/**
 * Header element for MuiPage component
 */
const PageHeader: FC<PageHeaderProps> = ({
    title,
    toolbar,
    responsive,
}): ReactElement => {
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));

    return (
        <Grid
            container
            direction="row"
            alignItems="flex-end"
            sx={{
                maxWidth: "100%",
            }}
            gap={2}
        >
            {title && (
                <Grid id="pageHeader_title" flexGrow={3}>
                    <Stack direction="row" alignItems={"flex-end"} spacing={2}>
                        <Typography
                            id="pageTitle"
                            variant="h4"
                            sx={{
                                fontWeight: 400,
                                fontSize: {
                                    xs: "24px",
                                    md: "34px",
                                },
                            }}
                        >
                            {title}
                        </Typography>
                        {responsive && isDesktop && <ResponsiveIcon />}
                    </Stack>
                </Grid>
            )}
            {toolbar && (
                <Grid
                    id="pageHeader_toolbar"
                    sx={{ minWidth: "300px" }}
                    flexGrow={1}
                >
                    {toolbar}
                </Grid>
            )}
        </Grid>
    );
};

export default PageHeader;
